<div style="margin-bottom: 30px;" [hidden]="!loader()">
  <div style="padding: 10px 20px 20px 20px" [ngStyle]="{'background-color': style.BG}">
    <div style="margin-top: 15px !important" uk-grid>
      <div class="uk-width-1-3">
        <label class="uk-form-label text-big" [ngStyle]="{'color': style.Text}">ชื่อผู้เอาประกัน</label>
      </div>
      <div class="uk-width-2-3">
        <label class="uk-form-label text-big" style="font-weight: bold; word-wrap: break-word" [ngStyle]="{'color': style.Text}">{{insuredetail_data()?.insuredName || '...'}}</label>
      </div>
    </div>
    <div style="margin-top: 15px !important" uk-grid>
      <div class="uk-width-1-3">
        <label class="uk-form-label text-big" [ngStyle]="{'color': style.Text}">ยี่ห้อ</label>
      </div>
      <div class="uk-width-2-3">
        <label class="uk-form-label text-big" style="font-weight: bold; word-wrap: break-word" [ngStyle]="{'color': style.Text}">{{insuredetail_data()?.carBrand || '...'}}</label>
      </div>
    </div>
    <div style="margin-top: 15px !important" uk-grid>
      <div class="uk-width-1-3">
        <label class="uk-form-label text-big" [ngStyle]="{'color': style.Text}">เลขทะเบียน</label>
      </div>
      <div class="uk-width-2-3">
        <label class="uk-form-label text-big" style="font-weight: bold; word-wrap: break-word" [ngStyle]="{'color': style.Text}">{{insuredetail_data()?.carNo || '...'}}</label>
      </div>
    </div>
    <div class="hline-auto"></div>
    <div>
      <label class="uk-form-label text-big" style="font-weight: bold" [ngStyle]="{'color': style.Text}">บริษัทประกันภัยเดิม</label>
    </div>
  </div>
  <div style="padding: 10px 20px 10px 20px;">
    <div>
      <label class="uk-form-label text-big" style="font-weight: bold; color: #82b0d6; word-wrap: break-word;">{{insuredetail_data()?.nameOldInsureBrand || ''}}</label>
    </div>
    <div uk-grid style="margin-top: 0px;">
      <div class="uk-width-2-5">
        <label class="uk-form-label text-large">หมายเลขกรมธรรม์</label>
      </div>
      <div class="uk-width-2-5">
        <label class="uk-form-label text-large" style="white-space: nowrap;">{{insuredetail_data()?.oldInsureNo || ''}}</label>
      </div>
    </div>
    <div uk-grid style="margin-top: 0px;">
      <div class="uk-width-2-5">
        <label class="uk-form-label text-large">วันที่ครบกำหนด</label>
      </div>
      <div class="uk-width-2-5">
        <label class="uk-form-label text-large" style="color: red; word-wrap:normal; white-space: nowrap;">{{expiredate() || ''}}</label>
      </div>
    </div>
  </div>
  
  
  <div style="padding: 10px 20px 10px 20px" [ngStyle]="{'background-color': style.BG}">
    <div>
      <label class="uk-form-label text-big" [ngStyle]="{'color': style.Text, 'font-weight': 'bold'}">บริษัทประกันภัยปีต่ออายุ</label>
    </div>
  </div>
  <div style="padding: 10px 20px 20px 20px">
    <div style="margin-top: 15px !important" uk-grid>
      <div class="uk-width-1-3">
        <img src="" id="offerlogo" width="100" height="100">
      </div>
      <div class="uk-width-2-3" uk-grid>
          <div class="vline"></div>
          <div style="padding-left: 0px !important">
            <div>
              <label class="uk-form-label text-big" style="font-weight: bold; color: #82b0d6; word-wrap: break-word;">{{insuredetail_data()?.offerInsureType || ''}}</label>
            </div>
            <div uk-grid style="margin-top: 0px;">
              <div class="uk-width-3-5">
                <label class="uk-form-label text-large">ทุนประกัน</label>
              </div>
              <div class="uk-width-2-5">
                <label class="uk-form-label text-large" style="white-space: nowrap;">{{numberWithCommas($safeNavigationMigration(insuredetail_data()?.offerInsureFund)) || '0'}} บาท</label>
              </div>
            </div>
            <div uk-grid style="margin-top: 0px;">
              <div class="uk-width-3-5">
                <label class="uk-form-label text-large">เบี้ยประกัน</label>
              </div>
              <div class="uk-width-2-5">
                <label class="uk-form-label text-large" style="white-space: nowrap;">{{numberWithCommas($safeNavigationMigration(insuredetail_data()?.offerInsureAmount)) || '0'}} บาท</label>
              </div>
            </div>
            <div uk-grid style="margin-top: 0px;">
              <div class="uk-width-3-5">
                <label class="uk-form-label text-large">การจัดซ่อม</label>
              </div>
              <div class="uk-width-2-5">
                <label class="uk-form-label text-large" style="white-space: nowrap;">{{insuredetail_data()?.offerInsureClaim || ''}}</label>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
  
  <div style="padding: 10px 20px 10px 20px" [ngStyle]="{'background-color': style.BG}">
    <div style="text-align: center;">
      <label class="uk-form-label text-big" [ngStyle]="{'color': style.Text, 'font-weight': 'bold'}">ความคุ้มครองตัวรถเอาประกัน</label>
    </div>
  </div>
  <div style="padding: 10px 30px 20px 30px">
    <div uk-grid class="uk-margin-remove-left">
      <div class="uk-width-1-6 uk-width-1-3@m uk-padding-remove-left">
        <img src="/assets/images/Icon_Renewal_Compare_New/icon_11_have.png" *ngIf="insuredetail_data()?.protection1 > 0" width="50" height="50">
        <img src="/assets/images/Icon_Renewal_Compare_New/icon_11_without.png" *ngIf="insuredetail_data()?.protection1 < 0 || insuredetail_data()?.protection1 == 0" width="50" height="50">
      </div>
      <div class="uk-width-1-2 uk-width-1-3@m" style="align-self: center; padding-left: 10px;">
        <label class="uk-form-label text-default" style="word-wrap: break-word;">ความเสียหายต่อตัวรถยนต์</label>
      </div>
      <div class="uk-width-1-3 uk-padding-remove-left uk-text-right" style="align-self: center; padding-right: 21px">
        <label class="uk-form-label text-large" style="word-wrap: break-word; color: #84B0D5;">{{numberWithCommas($safeNavigationMigration(insuredetail_data()?.protection1))}}</label>
      </div>
    </div>
    <div class="hline" style="margin: 0.3rem 0"></div>
    <div uk-grid class="uk-margin-remove-left">
      <div class="uk-width-1-6 uk-width-1-3@m uk-padding-remove-left">
        <img src="/assets/images/Icon_Renewal_Compare_New/icon_10_have.png" *ngIf="insuredetail_data()?.protection2 > 0" width="50" height="50">
        <img src="/assets/images/Icon_Renewal_Compare_New/icon_10_without.png" *ngIf="insuredetail_data()?.protection2 < 0 || insuredetail_data()?.protection2 == 0" width="50" height="50">
      </div>
      <div class="uk-width-1-2 uk-width-1-3@m" style="align-self: center; padding-left: 10px;">
        <label class="uk-form-label text-default" style="word-wrap: break-word;">รถยนต์สูญหาย/ไฟไหม้</label>
      </div>
      <div class="uk-width-1-3 uk-padding-remove-left uk-text-right" style="align-self: center; padding-right: 21px">
        <label class="uk-form-label text-large" style="word-wrap: break-word; color: #84B0D5;">{{numberWithCommas($safeNavigationMigration(insuredetail_data()?.protection2))}}</label>
      </div>
    </div>
    <div class="hline" style="margin: 0.3rem 0"></div>
    <div uk-grid class="uk-margin-remove-left">
      <div class="uk-width-1-6 uk-width-1-3@m uk-padding-remove-left">
        <img src="/assets/images/Icon_Renewal_Compare_New/icon_07_have.png" *ngIf="insuredetail_data()?.protection3 > 0" width="50" height="50">
        <img src="/assets/images/Icon_Renewal_Compare_New/icon_07_without.png" *ngIf="insuredetail_data()?.protection3 < 0 || insuredetail_data()?.protection3 == 0" width="50" height="50">
      </div>
      <div class="uk-width-1-2 uk-width-1-3@m" style="align-self: center; padding-left: 10px;">
        <label class="uk-form-label text-default" style="word-wrap: break-word;">ความเสียหายส่วนแรก</label>
      </div>
      <div class="uk-width-1-3 uk-padding-remove-left uk-text-right" style="align-self: center; padding-right: 21px;">
        <label class="uk-form-label text-large" style="word-wrap: break-word; color: #84B0D5;">{{numberWithCommas($safeNavigationMigration(insuredetail_data()?.protection3))}}</label>
      </div>
    </div>
  </div>

  <div style="padding: 10px 20px 10px 20px" [ngStyle]="{'background-color': style.BG}">
    <div style="text-align: center;">
      <label class="uk-form-label text-big" [ngStyle]="{'color': style.Text, 'font-weight': 'bold'}">ความคุ้มครองตัวบุคคลภายนอก</label>
    </div>
  </div>
  <div style="padding: 10px 30px 20px 30px">
    <div uk-grid class="uk-margin-remove-left">
      <div class="uk-width-1-6 uk-width-1-3@m uk-padding-remove-left">
        <img src="/assets/images/Icon_Renewal_Compare_New/icon_06_have.png" *ngIf="insuredetail_data()?.protection4 > 0" width="50" height="50">
        <img src="/assets/images/Icon_Renewal_Compare_New/icon_06_without.png" *ngIf="insuredetail_data()?.protection4 < 0 || insuredetail_data()?.protection4 == 0" width="50" height="50">
      </div>
      <div class="uk-width-1-2 uk-width-1-3@m" style="align-self: center; padding-left: 10px;">
        <label class="uk-form-label text-default " style="word-wrap: break-word;">ทรัพย์สินบุคคลภายนอก</label>
      </div>
      <div class="uk-width-1-3 uk-padding-remove-left uk-text-right" style="align-self: center;">
        <label class="uk-form-label text-large" style="word-wrap: break-word; color: #84B0D5;">{{numberWithCommas($safeNavigationMigration(insuredetail_data()?.protection4))}}
          <a class="black-icon" uk-icon="info" style="width: 13px; height: 13px; cursor: pointer; margin-left: 8px;" href="#modal-card-mf-10" uk-toggle></a>
          <div id="modal-card-mf-10" uk-modal>
            <div class="uk-modal-dialog" style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
              <div style="background-color: white; padding: 0px; margin: 10px;">
                <button class="uk-modal-close-default" type="button" uk-close></button>
                <div class="uk-modal-header" style="padding: 10px 20px;">
                  <div style="font-size: 1.2 rem !important; padding: 0px;">ทรัพย์สินบุคคลภายนอก</div>
                </div>
                <div class="uk-modal-body text-big" style="padding: 10px;">
                  บริษัทประกันภัย จะรับผิดชดใช้ค่าสินไหมทดแทนเพื่อความเสียหายต่อทรัพย์สินของบุคคลภายนอก ซึ่งผู้เอาประกันภัยจะต้องรับผิดชอบตามกฎหมาย และความรับผิดของบริษัทประกันภัยจะมีไม่เกินจำนวนเงินเอาประกันภัยที่ระบุไว้ในตารางกรมธรรม์ประกันภัย
                </div>
              </div>
            </div>
          </div>
        </label>
      </div>
    </div>
    <div class="hline" style="margin: 0.3rem 0"></div>
    <div uk-grid class="uk-margin-remove-left">
      <div class="uk-width-1-6 uk-width-1-3@m uk-padding-remove-left">
        <img src="/assets/images/Icon_Renewal_Compare_New/icon_13_have.png" *ngIf="insuredetail_data()?.protection5 > 0" width="50" height="50">
        <img src="/assets/images/Icon_Renewal_Compare_New/icon_13_without.png" *ngIf="insuredetail_data()?.protection5 < 0 || insuredetail_data()?.protection5 == 0" width="50" height="50">
      </div>
      <div class="uk-width-1-2 uk-width-1-3@m" style="align-self: center; padding-left: 10px;">
        <label class="uk-form-label text-default" style="word-wrap: break-word;">บาดเจ็บ ต่อคน</label>
      </div>
      <div class="uk-width-1-3 uk-padding-remove-left uk-text-right" style="align-self: center;">
        <label class="uk-form-label text-large" style="word-wrap: break-word; color: #84B0D5;">{{numberWithCommas($safeNavigationMigration(insuredetail_data()?.protection5))}}
          <a class="black-icon" uk-icon="info" style="width: 13px; height: 13px; cursor: pointer; margin-left: 8px;" href="#modal-card-mf-11" uk-toggle></a>
          <div id="modal-card-mf-11" uk-modal>
              <div class="uk-modal-dialog" style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
                  <div style="background-color: white; padding: 0px; margin: 10px;">
                      <button class="uk-modal-close-default" type="button" uk-close></button>
                      <div class="uk-modal-header" style="padding: 10px 20px;">
                          <div style="font-size: 1.2 rem !important; padding: 0px;">บาดเจ็บ ต่อคน</div>
                      </div>
                      <div class="uk-modal-body text-big" style="padding: 10px;">
                        ความรับผิดต่อบุคคลภายนอก ชีวิต ร่างกาย อนามัย ต่อคน  
                      </div>
                  </div>
              </div>
          </div>
        </label>
      </div>
    </div>
    <div class="hline" style="margin: 0.3rem 0"></div>
    <div uk-grid class="uk-margin-remove-left">
      <div class="uk-width-1-6 uk-width-1-3@m uk-padding-remove-left">
          <img src="/assets/images/Icon_Renewal_Compare_New/icon_14_have.png" *ngIf="insuredetail_data()?.protection6 > 0" width="50" height="50">
          <img src="/assets/images/Icon_Renewal_Compare_New/icon_14_without.png" *ngIf="insuredetail_data()?.protection6 < 0 || insuredetail_data()?.protection6 == 0" width="50" height="50">
      </div>
      <div class="uk-width-1-2 uk-width-1-3@m" style="align-self: center; padding-left: 10px;">
          <label class="uk-form-label text-default" style="word-wrap: break-word;">บาดเจ็บ ต่อครั้ง</label>
      </div>
      <div class="uk-width-1-3 uk-padding-remove-left uk-text-right" style="align-self: center;">
        <label class="uk-form-label text-large" style="word-wrap: break-word; color: #84B0D5;">{{numberWithCommas($safeNavigationMigration(insuredetail_data()?.protection6))}}
          <a class="black-icon" uk-icon="info" style="width: 13px; height: 13px; cursor: pointer; margin-left: 8px;" href="#modal-card-mf-12" uk-toggle></a>
          <div id="modal-card-mf-12" uk-modal>
              <div class="uk-modal-dialog" style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
                  <div style="background-color: white; padding: 0px; margin: 10px;">
                      <button class="uk-modal-close-default" type="button" uk-close></button>
                      <div class="uk-modal-header" style="padding: 10px 20px;">
                          <div style="font-size: 1.2 rem !important; padding: 0px;">บาดเจ็บ ต่อครั้ง</div>
                      </div>
                      <div class="uk-modal-body text-big" style="padding: 10px;">
                        ความรับผิดต่อบุคคลภายนอก ชีวิต ร่างกาย อนามัย ต่อครั้ง  
                      </div>
                  </div>
              </div>
          </div>
        </label>
      </div>
    </div>
    <div class="hline" style="margin: 0.3rem 0"></div>
    <div uk-grid class="uk-margin-remove-left">
      <div class="uk-width-1-6 uk-width-1-3@m uk-padding-remove-left">
          <img src="/assets/images/Icon_Renewal_Compare_New/icon_16_have.png" *ngIf="insuredetail_data()?.protection7 > 0" width="50" height="50">
          <img src="/assets/images/Icon_Renewal_Compare_New/icon_16_without.png" *ngIf="insuredetail_data()?.protection7 < 0 || insuredetail_data()?.protection7 == 0" width="50" height="50">
      </div>
      <div class="uk-width-1-2 uk-width-1-3@m" style="align-self: center; padding-left: 10px;">
        <label class="uk-form-label text-default" style="word-wrap: break-word;">ค่าความเสียหายส่วนแรก</label>
      </div>
      <div class="uk-width-1-3 uk-padding-remove-left uk-text-right" style="align-self: center; padding-right: 21px;">
        <label class="uk-form-label text-large" style="word-wrap: break-word; color: #84B0D5;">{{numberWithCommas($safeNavigationMigration(insuredetail_data()?.protection7))}}</label>
      </div>
    </div>
  </div>


  <div style="padding: 10px 20px 10px 20px" [ngStyle]="{'background-color': style.BG}">
    <div style="text-align: center;">
      <label class="uk-form-label text-big" [ngStyle]="{'color': style.Text, 'font-weight': 'bold'}">ความคุ้มครองผู้ขับขี่/ผู้โดยสาร</label>
    </div>
  </div>
  <div style="padding: 10px 30px 20px 30px">
    <div uk-grid class="uk-margin-remove-left">
      <div class="uk-width-1-6 uk-width-1-3@m uk-padding-remove-left">
          <img src="/assets/images/Icon_Renewal_Compare_New/icon_12_have.png" *ngIf="insuredetail_data()?.protection8 > 0" width="50" height="50">
          <img src="/assets/images/Icon_Renewal_Compare_New/icon_12_without.png" *ngIf="insuredetail_data()?.protection8 < 0 || insuredetail_data()?.protection8 == 0" width="50" height="50">
      </div>
      <div class="uk-width-1-2 uk-width-1-3@m" style="align-self: center; padding-left: 10px;">
        <label class="uk-form-label text-default" style="word-wrap: break-word;">จำนวนคนที่คุ้มครอง</label>
      </div>
      <div class="uk-width-1-3 uk-padding-remove-left uk-text-right" style="align-self: center; padding-right: 21px;">
        <label class="uk-form-label text-large" style="word-wrap: break-word; color: #84B0D5;">{{numberWithCommas($safeNavigationMigration(insuredetail_data()?.protection8))}}</label>
      </div>
    </div>
    <div class="hline" style="margin: 0.3rem 0"></div>
    <div uk-grid class="uk-margin-remove-left">
      <div class="uk-width-1-6 uk-width-1-3@m uk-padding-remove-left">
          <img src="/assets/images/Icon_Renewal_Compare_New/icon_17_have.png" *ngIf="insuredetail_data()?.protection9 > 0" width="50" height="50">
          <img src="/assets/images/Icon_Renewal_Compare_New/icon_17_without.png" *ngIf="insuredetail_data()?.protection9 < 0 || insuredetail_data()?.protection9 == 0" width="50" height="50">
      </div>
      <div class="uk-width-1-2 uk-width-1-3@m" style="align-self: center; padding-left: 10px;">
        <label class="uk-form-label text-default" style="word-wrap: break-word;">อุบัติเหตุส่วนบุคคล</label>
      </div>
      <div class="uk-width-1-3 uk-padding-remove-left uk-text-right" style="align-self: center;">
        <label class="uk-form-label text-large" style="word-wrap: break-word; color: #84B0D5;">{{numberWithCommas($safeNavigationMigration(insuredetail_data()?.protection9))}}
          <a class="black-icon" uk-icon="info" style="width: 13px; height: 13px; cursor: pointer; margin-left: 8px;" href="#modal-card-mf-15" uk-toggle></a>
          <div id="modal-card-mf-15" uk-modal>
              <div class="uk-modal-dialog" style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
                  <div style="background-color: white; padding: 0px; margin: 10px;">
                      <button class="uk-modal-close-default" type="button" uk-close></button>
                      <div class="uk-modal-header" style="padding: 10px 20px;">
                          <div style="font-size: 1.2 rem !important; padding: 0px;">อุบัติเหตุส่วนบุคคล</div>
                      </div>
                      <div class="uk-modal-body text-big" style="padding: 10px;">
                        อุบัติเหตุส่วนบุคคล เสียชีวิต สูญเสียอวัยวะ ทุพพลภาพถาวร
                      </div>
                  </div>
              </div>
          </div>
        </label>
      </div>
    </div>
    <div class="hline" style="margin: 0.3rem 0"></div>
    <div uk-grid class="uk-margin-remove-left">
      <div class="uk-width-1-6 uk-width-1-3@m uk-padding-remove-left">
          <img src="/assets/images/Icon_Renewal_Compare_New/icon_01_have.png" *ngIf="insuredetail_data()?.protection10 > 0" width="50" height="50">
          <img src="/assets/images/Icon_Renewal_Compare_New/icon_01_without.png" *ngIf="insuredetail_data()?.protection10 < 0 || insuredetail_data()?.protection10 == 0" width="50" height="50">
      </div>
      <div class="uk-width-1-2 uk-width-1-3@m" style="align-self: center; padding-left: 10px;">
        <label class="uk-form-label text-default" style="word-wrap: break-word;">ค่ารักษาพยาบาล</label>
      </div>
      <div class="uk-width-1-3 uk-padding-remove-left uk-text-right" style="align-self: center; padding-right: 21px;">
        <label class="uk-form-label text-large" style="word-wrap: break-word; color: #84B0D5;">{{numberWithCommas($safeNavigationMigration(insuredetail_data()?.protection10))}}</label>
      </div>
    </div>
    <div class="hline" style="margin: 0.3rem 0"></div>
    <div uk-grid class="uk-margin-remove-left">
      <div class="uk-width-1-6 uk-width-1-3@m uk-padding-remove-left">
          <img src="/assets/images/Icon_Renewal_Compare_New/icon_15_have.png" *ngIf="insuredetail_data()?.protection11 > 0" width="50" height="50">
          <img src="/assets/images/Icon_Renewal_Compare_New/icon_15_without.png" *ngIf="insuredetail_data()?.protection11 < 0 || insuredetail_data()?.protection11 == 0" width="50" height="50">
      </div>
      <div class="uk-width-1-2 uk-width-1-3@m" style="align-self: center; padding-left: 10px;">
        <label class="uk-form-label text-default" style="word-wrap: break-word;">ประกันตัวผู้ขับขี่</label>
      </div>
      <div class="uk-width-1-3 uk-padding-remove-left uk-text-right" style="align-self: center; padding-right: 21px;">
        <label class="uk-form-label text-large" style="word-wrap: break-word; color: #84B0D5;">{{numberWithCommas($safeNavigationMigration(insuredetail_data()?.protection11))}}</label>
      </div>
    </div>
  </div>

  <div style="padding: 10px 20px 10px 20px" [ngStyle]="{'background-color': style.BG}" *ngIf="insuredetail_data()?.specialProduct.length > 0">
    <div style="text-align: center;">
      <label class="uk-form-label text-big" [ngStyle]="{'color': style.Text, 'font-weight': 'bold'}">ความคุ้มครองพิเศษ</label>
    </div>
  </div>
  <div style="padding: 10px 30px 20px 30px;" *ngIf="insuredetail_data()?.specialProduct.length > 0">
    <div *ngFor="let y of insuredetail_data()?.specialProduct; let j = index;">
        <div *ngIf="j != 0" style="padding-right: 21px;">
            <div class="hline" style="margin: 0.6em 0 !important"></div>
        </div>
        <div style="line-height: 13px;" uk-grid>
          <div class="uk-width-1-2">
            <label class="uk-form-label text-large" style="word-wrap: break-word;">{{y.product_name}}</label>
          </div>
          <div class="uk-width-1-2 uk-padding-remove-left uk-text-right">
            <label class="uk-form-label text-large" style="word-wrap: break-word; color: #84B0D5; padding-right: 21px;">{{numberWithCommas(y.value)}}</label>
          </div>
        </div>
    </div>
  </div>

  <div style="padding: 10px 20px 10px 20px" [ngStyle]="{'background-color': style.BG}" *ngIf="insuredetail_data()?.additionalProduct.length > 0 && show_additional_products() == true">
    <div style="text-align: center;">
      <label class="uk-form-label text-big" [ngStyle]="{'color': style.Text, 'font-weight': 'bold'}">ผลิตภัณฑ์ที่เลือกซื้อได้เพิ่มเติม</label>
    </div>
  </div>
  <div style="padding: 10px 30px 20px 30px" *ngIf="insuredetail_data()?.additionalProduct.length > 0 && show_additional_products() == true">
      <div *ngFor="let y of insuredetail_data()?.additionalProduct; let j = index;">
          <div *ngIf="j != 0" style="padding-right: 21px;">
              <div class="hline-auto" style="margin: 0.6em 0 !important"></div>
          </div>
          <div style="line-height: 13px;" uk-grid>
            <div class="uk-width-3-5">
              <label class="uk-form-label text-large" style="word-wrap: break-word;">{{y.product_name}}</label>
            </div>
            <div class="uk-width-2-5 uk-padding-remove-left uk-text-right">
              <label uk-grid class="uk-form-label text-large" style="word-wrap: break-word;">
                <div class="uk-width-1-3 uk-padding-remove-left">ราคา</div>
                <div class="uk-width-2-3 uk-padding-remove-left">
                  <a style="color: #333333;" [ngStyle]="{'padding-right': (y.tooltip.length > 0) ? '10px' : '21px'}">
                   <span style="color: #84B0D5;">{{numberWithCommas(y.value)}}</span> บาท
                  </a>
                  
                  <!-- <span *ngIf="y.tooltip.length < 0 || y.tooltip.length == 0" uk-icon="info" style="float: right; width: 13px; height: 13px;">
                  </span> -->
                  
                  <!-- <span *ngIf="y.tooltip.length > 0" uk-icon="info" class="tooltip" style="float: right; width: 13px; height: 13px; cursor: pointer;">
                      <div class="tooltiptext">
                          <div *ngFor="let z of y.tooltip; let k = index;">
                              <div *ngIf="k!=0" class="hline" style="margin: 0.3em 0 !important"></div>
                              <div uk-grid style="margin-top: 0px;">
                                  <div class="uk-width-3-5" style="line-height: 13px;">
                                      <p style="margin-left: 10px; margin-right: 10px; word-wrap: break-word;">{{z.detail}}</p>
                                  </div>
                                  <div class="uk-width-2-5" style="line-height: 13px;">
                                      <p style="margin-left: 10px; margin-right: 10px; word-wrap: break-word;">{{z.value}}</p>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </span> -->
                  <a *ngIf="y.tooltip.length > 0" class="black-icon" uk-icon="info" style="float: right; width: 13px; height: 13px; cursor: pointer;" href="#modal-card-{{j}}" uk-toggle></a>
                  <div id="modal-card-{{j}}" uk-modal>
                      <div class="uk-modal-dialog" style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
                          <div style="background-color: white; padding: 0px; margin: 10px;">
                              <button class="uk-modal-close-default" type="button" uk-close></button>
                              <div class="uk-modal-header" style="padding: 10px 20px;">
                                  <div style="font-size: 1.2 rem !important; padding: 0px;">{{y.detail}}</div>
                              </div>
                              <div class="uk-modal-body" style="padding: 10px;">
                                  <div *ngFor="let z of y.tooltip; let k = index;">
                                      <div *ngIf="k!=0" class="hline-auto" style="margin: 0.3em 0 !important"></div>
                                      <div uk-grid class="text-big" style="margin-top: 0px;">
                                          <div class="uk-width-3-5" style="line-height: 1.0rem;">
                                              <p style="margin-left: 10px; margin-right: 10px; word-wrap: break-word;">{{z.detail}}</p>
                                          </div>
                                          <div class="uk-width-2-5" style="line-height: 1.0rem;">
                                              <p style="margin-left: 10px; margin-right: 10px; word-wrap: break-word;">{{z.value}}</p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <!-- <div class="uk-modal-footer uk-text-right">
                                  <button class="uk-button uk-button-default uk-modal-close" type="button">Cancel</button>
                                  <button class="uk-button uk-button-primary uk-modal-close" type="button">Enter</button>
                              </div> -->
                          </div>
                      </div>
                  </div>
                </div>
                </label>
              </div>
          </div>
    </div>
  </div>
  <div class="uk-flex uk-flex-center uk-padding uk-padding-remove-horizontal" style="padding-bottom: 0px; padding-top: 15px;">
    <button type="submit"
        class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right +btn-min-160" [ngStyle]="{'background-color': style.Button}" style="min-width: 150px !important; font-size: 13px;" (click)="onSubmit()">
        <img src="" id="offerlogo1" width="25" height="25"> เลือก {{insuredetail_data()?.nameOfferInsureBrand}}
    </button>
  </div>
  <div style="text-align: center; margin-top: 8px;" *ngIf="insuredetail_data()?.compareLength > 1">
    <a (click)="onCompare()"><span style="font-size: 1rem;"><u>เปรียบเทียบประกันอื่น</u></span></a>
  </div>
</div>

<app-loader *ngIf="!loader()"></app-loader>